import React from 'react';
import { connect } from 'react-redux';
// actions
import { getLensPackages, getPowers } from '../../../actionCreators/editPower';
// components
import { Form } from 'react-final-form';
import { PowerInputs, getPrescription, getSubmitValues, getDirtyValues } from './PowerInputs';
import ItemInfo from './ItemInfo';
import PackageGroup from './PackageGroup';
// utils
import { sameFields } from './power-utils';

class PowerGlass extends React.PureComponent {
    constructor(props) {
        super(props);
        const { options, prescription } = props.item || {};
        const presc = getPrescription(prescription);
        const p = options && options[0] || {};
        const pristine = { pkgid: p.oid, pkgname: p.name, ...presc };
        this.state = { pristine };
        this.mutators = {
            onChange: (args, state, utils) => {
                utils.changeValue(state, args[0], () => args[1]);
            }
        };
        this.onChange = this.onChange.bind(this);
        this.getPackageName = this.getPackageName.bind(this);
        this.submit = this.submit.bind(this);
    }
    componentDidMount() {
        const { getLensPackage, getPowers, item } = this.props;
        const { productId, prescription = {}, frameType } = item || {};
        const powerType = prescription.powerType && prescription.powerType.toLowerCase();
        if (productId) {
            getPowers({ productId, powerType });
            getLensPackage({ prodId: productId, powerType, frameType });
        }
    }
    componentDidUpdate(prevProps) {
        const { item } = this.props;
        if (prevProps.item !== item && item) {
            const { options, prescription } = item || {};
            const presc = getPrescription(prescription);
            const p = options && options[0] || {};
            const pristine = { pkgid: p.oid, pkgname: p.name, ...presc };
            (() => this.setState({ pristine }))();
        }
    }
    onChange(name, val) {
        const [key, type] = name.split('-');
        if (sameFields.indexOf(key) >= 0) {
            const ctype = type === 'left' ? 'right' : 'left';
            this.form_mutators.onChange(key + '-' + ctype, val || undefined);
        }
        if (key === 'bottomDistance' && !val) {
            this.form_mutators.onChange('lensHeight-left', undefined);
            this.form_mutators.onChange('lensHeight-right', undefined);
            this.form_mutators.onChange('lensWidth-left', undefined);
            this.form_mutators.onChange('lensWidth-right', undefined);
        }
    }
    getPackageName(name) {
        this.selectedPackageName = name;
    }
    submit(values) {
        const { item, powers, submitCallback, dataLocale: { PLEASE_ENTER_FITTING_HEIGHT, ENTERED_FITTING_HEIGHT } } = this.props;
        const { lensType } = item || {};
        if (lensType === 'BIFOCAL' && !values['bottomDistance-left']) {
            alert(PLEASE_ENTER_FITTING_HEIGHT);
            return;
        }
        if (lensType === 'BIFOCAL' && values['bottomDistance-left'] > 32) {
            alert(`${ENTERED_FITTING_HEIGHT} > 32`);
            return;
        }
        const dirtyValues = getDirtyValues(this.state.pristine, values);
        const submitValues = getSubmitValues(dirtyValues, powers);
        const changedPackage = this.state.pristine.pkgid !== values.pkgid ? { name: this.selectedPackageName, value: values.pkgid } : null;
        submitCallback(submitValues, item, changedPackage);
    }
    render() {
        const { dataLocale, item, lensPackages = [], powers = [], powerSubmittedItemId, powerSubmitted, packageSubmittedItemId, packageSubmitted } = this.props;
        const { name, productId, lensType } = item || {};
        return (
            <React.Fragment>
                <ItemInfo name={name} productId={productId} dataLocale={dataLocale} />
                <Form
                    initialValues={this.state.pristine}
                    mutators={this.mutators}
                    onSubmit={this.submit}
                >
                    {({ handleSubmit, form, values }) => {
                        this.form_mutators = form.mutators;
                        return (
                            <form onSubmit={handleSubmit} noValidate>
                                <div className="padding-b20"><PowerInputs dataLocale={dataLocale} powers={powers} onChange={this.onChange} onSelect={this.onChange} values={values} isBifocal={lensType === 'BIFOCAL'} /></div>
                                <PackageGroup dataLocale={dataLocale} name="pkgid" currentPackage={this.state.pristine.pkgname} packages={lensPackages} callback={this.getPackageName} />
                                {powerSubmittedItemId && item.id === powerSubmittedItemId && <div className={`margin-t10 margin-b10 fw700 fs14${powerSubmitted ? ' success-msg' : ' error-msg'}`}>{powerSubmitted ? 'Power Details Updated Successfully' : 'Power Details Update Failed'}</div>}
                                {packageSubmittedItemId && item.id === packageSubmittedItemId && <div className={`margin-t10 margin-b10 fw700 fs14${packageSubmitted ? ' success-msg' : ' error-msg'}`}>{packageSubmitted ? 'Package Updated Successfully' : 'Package Update Failed'}</div>}
                                <div className="submit-button margin-b20 margin-t15">
                                    <button className="form-SLA_field-row_submit bora-2 fs16 fw700 text-capitalize" type="submit" style={{ width: '200px' }}>{dataLocale.SUBMIT}</button>
                                </div>
                            </form>
                        );
                    }}
                </Form>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { productId: pid, prescription = {} } = ownProps.item || {};
    const powerType = prescription.powerType && prescription.powerType.toLowerCase();
    const lensPackages = state.editPower.pidToPkgs ? state.editPower.pidToPkgs[pid + powerType] : undefined;
    const powers = state.editPower.pidToPowers ? state.editPower.pidToPowers[pid + powerType] : undefined;
    return {
        lensPackages,
        powers,
        powerSubmittedItemId: state.success.powerSubmittedItemId,
        powerSubmitted: state.success.powerSubmitted,
        packageSubmittedItemId: state.success.packageSubmittedItemId,
        packageSubmitted: state.success.packageSubmitted,
        dataLocale: state.locale
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getLensPackage: data => dispatch(getLensPackages(data)),
        getPowers: data => dispatch(getPowers(data))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PowerGlass);
